export { default as DePrivacyStatement } from './DeVersion';
export { default as EnPrivacyStatement } from './EnVersion';
export { default as EsPrivacyStatement } from './EsVersion';
export { default as FrPrivacyStatement } from './FrVersion';
export { default as NlPrivacyStatement } from './NlVersion';
